module.exports = __webpack_public_path__ + "img/DNADamage-OVCA_10X_WTA.f802ee82.png";